import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type SelectedVoorschrift = {
  id: string;
  type: 'voorschrift';
};

type SelectedSubparagraaf = {
  id: string;
  type: 'subparagraaf';
};

type SelectedParagraaf = {
  id: string;
  type: 'paragraaf';
};

type SelectedHoofdstuk = {
  id: string;
  type: 'hoofdstuk';
};

type SelectedObject =
  | SelectedVoorschrift
  | SelectedSubparagraaf
  | SelectedParagraaf
  | SelectedHoofdstuk;

export enum EditorView {
  DEFAULT = 'default',
  ADD = 'add',
  DRAGNDROP = 'dragndrop',
  RECOVER = 'recover',
}

export enum SidebarLeftTab {
  INDEX = 'index',
  FILTER = 'filter',
}

interface EditorStoreState {
  view: EditorView;
  isSidebarLeftOpen: boolean;
  sidebarLeftTabId: SidebarLeftTab;
  selectedObject?: SelectedObject;
  includeCheckedComments: boolean;
}

interface EditorStoreActions {
  setView: (view: EditorStoreState['view']) => void;
  setSidebarLeftOpen: (isOpen: boolean) => void;
  setSidebarLeftTabId: (tabId: SidebarLeftTab) => void;
  reset: () => void;
  selectObject: (selectedObject: SelectedObject) => void;
  clearSelectedObject: () => void;
  setIncludeCheckedComments: (includeCheckedComments: boolean) => void;
}

export const EDITOR_STORE_INITIAL_STATE: EditorStoreState = {
  view: EditorView.DEFAULT,
  isSidebarLeftOpen: false,
  sidebarLeftTabId: SidebarLeftTab.INDEX,
  selectedObject: undefined,
  includeCheckedComments: false,
};

export const useEditorStore = create<EditorStoreState & EditorStoreActions>()(
  persist(
    (set) => ({
      ...EDITOR_STORE_INITIAL_STATE,
      setView: (view) => set({ view }),
      setSidebarLeftOpen: (isSidebarLeftOpen) => set({ isSidebarLeftOpen }),
      setSidebarLeftTabId: (sidebarLeftTabId) => set({ sidebarLeftTabId }),
      reset: () => set({ ...EDITOR_STORE_INITIAL_STATE }),
      selectObject: (selectedObject) => set({ selectedObject }),
      clearSelectedObject: () => set({ selectedObject: undefined }),
      setIncludeCheckedComments: (includeCheckedComments) =>
        set({ includeCheckedComments }),
    }),
    {
      name: 'editor-store',
      partialize: (state) => ({
        isSidebarLeftOpen: state.isSidebarLeftOpen,
      }),
    }
  )
);
